/**
 * Created by sivanh on 13/06/2018.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var _ = require("underscore");
    var ScheduleModel = require("models/entities/ScheduleModel");
    var RevisionedCollection = require("collections/RevisionedCollection");
    var ApiResources = require("assets/data/apiResources.json");

    var NAME = "SchedulesCollection";

    var SchedulesCollection = RevisionedCollection.extend({
        model: ScheduleModel,
        resource: ApiResources.AccountConfig.WorkingHours,
        name: NAME,
        initialize: function(models, options) {
            RevisionedCollection.prototype.initialize.call(this, models, options);
            this.defaultId = null;
        },
        fetchSuccess: function( ){
            this._setDefaultId();
        },
        getDefaultId: function() {
            return this.defaultId;
        },
        getDefaultItem: function() {
            var defaultItem = null;
            if (!_.isNull(this.getDefaultId())) {
                defaultItem = this.get(this.getDefaultId());
            }
            return defaultItem;
        },
        _setDefaultId: function() {
            var defaultModel = this.find(function(model){ return model.isSystemDefault(); });
            if (!_.isEmpty(defaultModel)) {
                this.defaultId = defaultModel.id;
            }
        }

    });

    SchedulesCollection.NAME = NAME;

    return SchedulesCollection;
});
